import React, { useEffect, useState } from 'react';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import TableComponent from '../DataTable/TableComponent';
import Pagination from '../Pagination/Pagination';

const LocationTable = ({ linkId, title }) => {
    const [selectedFilter, setSelectedFilter] = useState('COUNTRY')
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const columns = [
        { name: "#ID", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Location", selector: (row) => row?.channel_name, grow: 3.4, cell: (row) => (
                <p className="mb-0.5 font-semibold text-sm text-primary">{row?.name || "N/A"}</p>
            )
        }, {
            name: "Clicks + Scans", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.count}</p>
            )
        }, {
            name: "%", center: "true", selector: (row) => row?.category, cell: (row) => (
                <p className="mb-0">{row?.percentage || '0%'}</p>
            )
        },
    ];

    async function getTableData() {
        let resp = await getApi(urlApi.getAnalysisLocationTableData + linkId + "?page=" + activePage + "&limit=" + perPage);
        if (resp.responseCode === 200) {
            setTableData({
                data: selectedFilter == "COUNTRY" ? resp.data?.countryData?.items : resp.data?.cityData?.items,
                totalCount: selectedFilter == "COUNTRY" ? resp.data?.countryData?.count : resp.data?.cityData?.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    function handlePageChange(page) {
        setActivePage(page);
    }

    useEffect(() => {
        getTableData();
    }, [linkId, activePage, perPage, selectedFilter])

    const handleTabChange = (tab) => {
        setActivePage(1);
        setSelectedFilter(tab);
    }

    return (
        <div className='p-2 bg-white rounded-lg'>
            <div className='flex items-center gap-3 justify-between mb-2'>
                <p className='mb-0 text-md font-bold text-[var(--grey)]'>{`${title ?? 'Clicks/Scans'} by location`}</p>
                <div className="flex outline outline-[#383c5120] outline-[1px] p-1 rounded-lg gap-2">
                    <button className={`${selectedFilter == "COUNTRY" ? 'bg-primary text-white' : 'bg-transparent'} px-3 py-1 rounded-lg font-semibold text-xs`} onClick={() => handleTabChange('COUNTRY')}>Countries</button>
                    <button className={`${selectedFilter == "CITY" ? 'bg-primary text-white' : 'bg-transparent'} px-3 py-1 rounded-lg font-semibold text-xs`} onClick={() => handleTabChange('CITY')}>Cities</button>
                </div>
            </div>
            <TableComponent
                isHeader={true}
                columns={columns}
                data={tableData?.data}
                totalRows={tableData?.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </div>
    )
}

export default LocationTable